import React, { useState, useEffect } from "react";
import { FaMobileAlt, FaArrowUp } from "react-icons/fa";

export default function FloatingActionButton() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [pulse, setPulse] = useState(true);
  const [showFABs, setShowFABs] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector("footer");
      let footerTop = footer ? footer.getBoundingClientRect().top + window.scrollY : Infinity;
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      // Show FABs only above the footer
      if (scrollY + windowHeight < footerTop) {
        setShowFABs(true);
      } else {
        setShowFABs(false);
      }

      // Show Scroll-to-Top button after scrolling 500px
      setShowScrollTop(scrollY > 500 && scrollY + windowHeight < footerTop);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    handleScroll(); // initial check
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!showFABs) return null; // hide both FABs if footer reached

  return (
    <>
      {/* 🎵 Book Ride FAB */}
      <button
        style={{
          position: "fixed",
          bottom: "24px",
          right: "24px",
          zIndex: 9999,
          background: "linear-gradient(to right, #E63946, #FFC300)",
          color: "white",
          width: "64px",
          height: "64px",
          borderRadius: "50%",
          border: "none",
          boxShadow: "0 8px 30px rgba(230, 57, 70, 0.4)",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "28px",
          transition: "all 0.3s ease",
          animation: pulse ? "pulse 2s infinite, dance 1.2s infinite ease-in-out" : "none",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.1)";
          setPulse(false);
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          setPulse(true);
        }}
      >
        <FaMobileAlt />
      </button>

      {/* ↑ Scroll to Top */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          style={{
            position: "fixed",
            bottom: "100px",
            right: "24px",
            zIndex: 9999,
            background: "white",
            color: "#E63946",
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            border: "2px solid #E63946",
            boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "22px",
            transition: "all 0.3s ease",
            animation: "fadeIn 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.1) translateY(-2px)";
            e.currentTarget.style.background = "#E63946";
            e.currentTarget.style.color = "white";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.background = "white";
            e.currentTarget.style.color = "#E63946";
          }}
        >
          <FaArrowUp />
        </button>
      )}

      <style>{`
        @keyframes pulse {
          0%, 100% { box-shadow: 0 8px 30px rgba(230, 57, 70, 0.4), 0 0 0 0 rgba(230, 57, 70, 0.7); }
          50% { box-shadow: 0 8px 30px rgba(230, 57, 70, 0.4), 0 0 0 10px rgba(230, 57, 70, 0); }
        }
        @keyframes fadeIn { from { opacity: 0; transform: scale(0.8); } to { opacity: 1; transform: scale(1); } }
        @keyframes dance {
          0% { transform: rotate(0deg); } 20% { transform: rotate(-10deg); }
          40% { transform: rotate(10deg); } 60% { transform: rotate(-8deg); }
          80% { transform: rotate(8deg); } 100% { transform: rotate(0deg); }
        }
      `}</style>
    </>
  );
}
